import { scrollAndHighlightField } from './scroll_to_field_util'

// Booleans in tenant config are stored as the strings 'True'/'False' (not real
// booleans), so a plain truthy check would treat 'False' as "on".
export function truthy(value) {
  if (value === true) return true
  if (value === 'True') return true
  if (typeof value === 'string') return value.trim() !== '' && value !== 'False'
  return false
}

function isFieldEmpty(value) {
  if (value === null || value === undefined) return true
  if (typeof value === 'string') return value.trim() === ''
  if (Array.isArray(value)) return value.length === 0
  return false
}

// Rule shapes supported by evaluateRequiredRules():
//   { toggle: 'x_enabled', requires: [{ field: 'x_y', label: 'Y' }, ...] }
//     -> when model[toggle] is truthy, every listed field must be non-empty.
//   { toggle: 'x_enabled', when: model => bool, requires: [...] }
//     -> requires are only checked when `when(model)` is also true.
//   { toggle: 'x_enabled', oneOf: { key, fields: [...], message } }
//     -> when enabled, at least one of `fields` must be non-empty, otherwise
//        a single error is recorded under `key`.
export default {
  data() {
    return {
      requiredErrors: {},
    }
  },
  methods: {
    requiredState(key) {
      return this.requiredErrors[key] ? false : null
    },
    requiredFeedback(key) {
      return this.requiredErrors[key] || ''
    },
    hasRequiredErrors() {
      return Object.values(this.requiredErrors).some(e => !!e)
    },
    firstRequiredErrorKey() {
      return Object.keys(this.requiredErrors).find(k => !!this.requiredErrors[k])
    },
    firstRequiredErrorMessage() {
      const key = this.firstRequiredErrorKey()
      return key ? this.requiredErrors[key] : ''
    },
    evaluateRequiredRules(rules, model) {
      this.requiredErrors = {}
      for (const rule of rules || []) {
        if (!truthy(model[rule.toggle])) continue
        if (rule.when && !rule.when(model)) continue

        if (rule.requires) {
          for (const req of rule.requires) {
            if (isFieldEmpty(model[req.field])) {
              this.$set(this.requiredErrors, req.field, `${req.label || req.field} is required when this feature is enabled`)
            }
          }
        }

        if (rule.oneOf) {
          const { key, fields, message } = rule.oneOf
          const satisfied = fields.some(f => !isFieldEmpty(model[f]))
          if (!satisfied) {
            this.$set(this.requiredErrors, key, message)
          }
        }

        if (rule.validate) {
          const result = rule.validate(model)
          if (result) {
            this.$set(this.requiredErrors, result.key, result.message)
          }
        }
      }
    },
    scrollToFirstRequiredError() {
      scrollAndHighlightField(this, this.firstRequiredErrorKey())
    },
  },
  watch: {
    loading(newVal) {
      if (newVal) {
        this.requiredErrors = {}
      }
    }
  },
}
